export default {
  getToken: '/uauth/auth/getToken'
}